import { render, staticRenderFns } from "./ModalStoryDeleteComponent.vue?vue&type=template&id=7c821154&scoped=true&"
import script from "./ModalStoryDeleteComponent.vue?vue&type=script&lang=js&"
export * from "./ModalStoryDeleteComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModalStoryDeleteComponent.vue?vue&type=style&index=0&id=7c821154&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c821154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VLayout})
